import globalStore from '@/services/global.state';
import {toPriceStr} from '@/utils';
import {Button} from 'antd-mobile';
import React, {useContext} from 'react';
import {ReactComponent as AmountRefresh} from '@/assets/icons/me/amount-refresh.svg';
import {ReactComponent as ChevronRight} from '@/assets/icons/chavron-right.svg';
import {ReactComponent as History} from '@/assets/icons/me/history.svg';
import {RefreshProvider, useGoTo} from './hooks';
import {useLogin} from '@/services/global.store';
import {Image} from '@/components-v2/Image';
import styles from '../../me.module.scss';

const MyWalletTotal = () => {
  const {t, login, user, toRecharge} = useGoTo();
  const {refresh} = useContext(RefreshProvider);
  return (
    <div className="flex justify-between items-center">
      <div className="flex flex-col">
        <div className="flex flex-col gap-1">
          <span className="text-t2 text-xs font-normal">
            {t('me.money.myWallet')}
          </span>
          <div className="flex items-center gap-3">
            <div
              className="flex flex-row h-3.5 items-center"
              onClick={toRecharge}>
              {login ? (
                <span className="text-t1 text-sm leading-[.875rem] font-din font-black">
                  {globalStore.currency}
                  <span className="text-xl">
                    {toPriceStr(user?.totalBalance || 0, {
                      showCurrency: false,
                    })}
                  </span>
                </span>
              ) : (
                <span className="text-t1 text-xl leading-[.875rem] font-din font-black">
                  ********
                </span>
              )}
            </div>

            <Button
              className="size-4 p-0 min-w-0 h-4 rounded-none bg-transparent"
              onClick={() => refresh?.()}>
              <AmountRefresh className="size-4" />
            </Button>
          </div>
        </div>
      </div>

      <Button
        className="size-4 p-0 min-w-0 h-4 rounded-none bg-transparent"
        onClick={toRecharge}>
        <ChevronRight className="size-4 text-t1" />
      </Button>
    </div>
  );
};

const MyWalletBalanceItem = ({
  title,
  amount,
  onClick,
}: {
  title: string;
  amount?: number;
  onClick?: () => void;
}) => {
  const login = useLogin();
  return (
    <div className="flex flex-1 flex-col gap-1" onClick={onClick}>
      <span className="text-t2 text-xs font-normal">{title}</span>
      <div className="flex items-center gap-3">
        <div className="flex flex-row h-3.5 items-center" onClick={onClick}>
          {login ? (
            <span className="text-t1 text-sm leading-[.875rem] font-din font-black">
              {globalStore.currency}
              <span className="text-base">
                {toPriceStr(amount || 0, {
                  showCurrency: false,
                })}
              </span>
            </span>
          ) : (
            <span className="text-t1 text-xl leading-[.875rem] font-din font-black">
              ********
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

const MyWalletRecordItem = ({
  icon,
  title,
  onTitleClick,
  subIcon,
  subTitle,
  onSubTitleClick,
}: {
  icon: string;
  title: string;
  onTitleClick?: () => void;
  subIcon: React.ReactNode;
  subTitle: string;
  onSubTitleClick?: () => void;
}) => {
  return (
    <div className="flex flex-col items-center gap-3">
      <div className="flex gap-3 items-center" onClick={onTitleClick}>
        <Image src={icon} className="size-8" />
        <span className="text-t1 font-bold">{title}</span>
      </div>
      <div className="flex gap-1 items-center" onClick={onSubTitleClick}>
        {subIcon}
        <span className="text-t2 text-xs">{subTitle}</span>
      </div>
    </div>
  );
};

const MeWallet = () => {
  const {
    t,
    user,
    toRecharge,
    toWithdraw,
    toRechargeRecords,
    toWithdrawRecords,
  } = useGoTo();
  return (
    <div className="flex flex-col z-[5]">
      <div className="flex flex-col gap-4 rounded-lg bg-white p-4">
        <MyWalletTotal />
        <div className="flex flex-row border-t border-t-[#E8EAEE] pt-3">
          <MyWalletBalanceItem
            title={t('me.money.cashBalance')}
            amount={user?.rechargeAmount}
            onClick={toRecharge}
          />
          <MyWalletBalanceItem
            title={t('me.money.withdrawAmount')}
            amount={user?.canWithdrawAmount}
            onClick={toWithdraw}
          />
        </div>

        <div
          className={`border-t border-t-[#E8EAEE] pt-3 ${styles['me-wallet-menu-linear']}`}>
          <div className="flex flex-row justify-between px-3">
            <MyWalletRecordItem
              icon={require('@/assets/icons/me/recharge.webp')}
              title={t('label.deposit')}
              subIcon={<History className="size-5" />}
              subTitle={t('me.label.rechargeRecord')}
              onTitleClick={toRecharge}
              onSubTitleClick={toRechargeRecords}
            />

            <div className="w-px bg-[#E8EAEE]" />

            <MyWalletRecordItem
              icon={require('@/assets/icons/me/withdraw.webp')}
              title={t('label.withdraw')}
              subIcon={<History className="size-5" />}
              subTitle={t('me.label.withdrawRecord')}
              onTitleClick={toWithdraw}
              onSubTitleClick={toWithdrawRecords}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeWallet;
